
// Core
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LocobookComponent } from './locobook.component';
import { SearchComponent } from './search.component';
import { AirBookingDetailsComponent } from './pages/air-booking-details/air-booking-details.component';
import { IqbaPathSegment } from './iqba-paths';
import { AncillaryServicesPageComponent } from "app_locobook/pages/ancillary-services-page/ancillary-services-page.component";

const routes: Routes = [
    {
        path: "",
        component: LocobookComponent,
        children: [
            {
                path: `${IqbaPathSegment.Hosts}/:host/bookings/:booking`,
                component: AirBookingDetailsComponent
            },
            {
                path: `${IqbaPathSegment.Search}/:idSearch`,
                component: SearchComponent
            },
            {
                path: `${IqbaPathSegment.Search}/:idSearch/:idQuote`,
                component: SearchComponent
            },
            {
                path: `${IqbaPathSegment.Search}/:idSearch/:idQuote/${IqbaPathSegment.Alternative}/:idAlternative`,
                component: SearchComponent
            },
            {
                path: `${IqbaPathSegment.Search}/:idSearch/:idQuote/${IqbaPathSegment.AncillaryServices}`,
                component: SearchComponent
            },
            {
                path: `${IqbaPathSegment.Search}/:idSearch/:idQuote/${IqbaPathSegment.Alternative}/:idAlternative/${IqbaPathSegment.AncillaryServices}`,
                component: SearchComponent
            },
            {
                path: `${IqbaPathSegment.Search}`,
                component: SearchComponent
            },

            {
                path: "", //no params, default page
                redirectTo: "/locobook/search"
            },
        ]
    },

];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LocobookRoutingModule { }
